import styled from 'styled-components'

const StyledIconBase = styled.span`
  display: inline-block;
  line-height: 0;
  width: 22px;
  height: 22px;
  margin-right: 16px;
  vertical-align: middle;

  svg {
    width: 100%;
    height: auto;

    path {
      fill: ${(props) => props.theme.colors.blue};
    }

    ellipse {
      fill: ${(props) => props.theme.colors.white};
    }
  }
`

const StyledIconPhone = styled(StyledIconBase)`
  height: 22px;
  svg {
    margin-top: 4px;
    width: 80%;
    margin-left: 10%;
  }
`

const StyledIconMapPin = styled(StyledIconBase)`
  height: 25px;
  svg {
    margin-top: 4px;
    width: 70%;
    margin-left: 15%;
  }
`

const StyledIconTick = styled(StyledIconBase)`
  background-color: ${(props) => props.theme.colors.blue};
  border-radius: 11px;
  text-align: center;
  svg {
    width: 11px;
    height: 9px;
    margin-top: 7px;
    margin-left: 1px;
    path {
      fill: ${(props) => props.theme.colors.white};
    }
  }
`

const StyledIconHeart = styled.span`
  svg {
    width: 28px;
    height: 25px;
  }
`

export { StyledIconHeart, StyledIconPhone, StyledIconMapPin, StyledIconTick }
